<template>
  <div
    class="card-ui main-app-signin login-card-signin ml-auto mr-auto"
    style="box-shadow: none"
  >
      <h2 style="padding: 10px">Sign in</h2>
      <el-form
        style="margin-top: 26px;"
        :model="loginForm"
        :rules="loginRules"
        ref="loginForm"
        label-width="120px"
        :disabled="bLoginFormSubmitting"
      >
        <!-- username -->
        <div class="el-form-element">
          <el-form-item
            prop="userId"
            label-width="0"
            style="margin-bottom: 20px;width: 100%"
          >
            <el-input
              :placeholder="$t('scenes.auth.login.userForm.userId')"
              size="large"
              v-model="loginForm.userId"
              @keyup.enter.native="doLogin()"
            >
              <i slot="prefix" class="el-input__icon material-icons input-icon"
                >email</i
              >
            </el-input>
          </el-form-item>
        </div>
        <!-- password -->
        <div class="el-form-element">
          <el-form-item
            prop="password"
            label-width="0"
            style="margin-bottom: 15px;width: 100%"
          >
            <el-input
              :placeholder="$t('scenes.auth.login.userForm.password')"
              size="large"
              v-model="loginForm.password"
              type="password"
              @keyup.enter.native="doLogin()"
            >
              <i slot="prefix" class="el-input__icon material-icons input-icon"
                >lock_outline</i
              >
            </el-input>
          </el-form-item>
        </div>
        <!-- remember me -->
        <div class="form-element">
          <el-checkbox v-model="loginForm.rememberMe">{{
            $t("scenes.auth.login.userForm.rememberMe")
          }}</el-checkbox>
        </div>
      </el-form>
      <!-- login -->
      <div class="form-element">
        <el-button
          type="primary"
          style="width: 100%"
          @click="doLogin"
          :disabled="
            bLoginFormSubmitting || !loginForm.userId || !loginForm.password
          "
          >{{ $t("scenes.auth.login.userForm.signIn") }}</el-button
        >
      </div>
      <div style="text-align: center; padding-left: 10px; padding-right: 10px;color: #7a7a7a">- or -</div>
      <!-- register -->
      <div class="form-element">
        <el-button
            type="info"
            style="width: 100%"
            @click="onClickCreateAccountBtn()"
        >Create an account</el-button
        >
      </div>
      <!-- forgot password -->
      <div class="form-element">
        <el-button
          type="text"
          style="float:right"
          @click="onClickForgotPassword"
          :disabled="bLoginFormSubmitting"
          >{{ $t("scenes.auth.login.userForm.forgottenPassword") }}</el-button
        >
      </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { Notification } from "element-ui";
import { SF_COOKIE_REMEMBER_ME } from "../persistence/constants";
import Cookies from "js-cookie";
import config from "@/config";
export default {
  name: "LoginForm",
  data() {
    return {
      bLoginFormSubmitting: false,
      loginForm: {
        userId: null,
        password: null,
        rememberMe: true
      },
      loginRules: {
        userId: [
          {
            required: true,
            message: this.$t("scenes.auth.login.formErrors.userId.required"),
            trigger: "blur"
          },
          {
            type: "email",
            message: this.$t("scenes.auth.login.formErrors.userId.valid"),
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: this.$t("scenes.auth.login.formErrors.password.required"),
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    ...mapActions(["login", "me", "uiShowForgotPasswordDialog"]),
    onClickCreateAccountBtn() {
      this.$emit("evt-on-click-create-account");
    },
    onClickForgotPassword() {
      this.uiShowForgotPasswordDialog();
    },
    doLogin() {
      this.$refs["loginForm"].validate(async valid => {
        if (valid) {
          this.bLoginFormSubmitting = true;
          try {
            await this.login({
              username: this.loginForm.userId,
              password: this.loginForm.password
            });
            await this.me();
            this.authSuccess(this.loginForm.userId);
          } catch (err) {
            console.log("Login failed with error");
            console.log(err);
            this.authError();
          }
        }
      });
    },
    authError() {
      this.bLoginFormSubmitting = false;
      Notification.info({
        title: this.$t("scenes.auth.login.errors.AUTH_ERROR.title"),
        message: this.$t("scenes.auth.login.errors.AUTH_ERROR.message")
      });
    },
    authSuccess: function(inEmailAddress) {
      this.$message({
        message: `You are now signed in as ${inEmailAddress}`,
        type: "success"
      });
      Cookies.set(
        SF_COOKIE_REMEMBER_ME,
        this.loginForm.rememberMe,
        config.get("COOKIE_SETTINGS")
      );
      this.bLoginFormSubmitting = false;
      this.$emit("evt-auth-success");
    }
  }
};
</script>

<style scoped></style>
